<template>
	<div class="login-page">
		<!-- Navbar -->
		<nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
			<div class="container">
				<div class="navbar-wrapper">
					<div class="navbar-toggle">
						<button type="button" class="navbar-toggler">
							<span class="navbar-toggler-bar bar1"></span>
							<span class="navbar-toggler-bar bar2"></span>
							<span class="navbar-toggler-bar bar3"></span>
						</button>
					</div>
					<a class="navbar-brand" href="https://www.bigscoots.com/" target="_blank">
						<img src="../assets/img/bigscoots-logo/logo_light.svg" alt="Bigscoots" width="70%" class="center login-bs-logo">
					</a>
				</div>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
				</button>
				<div class="collapse navbar-collapse justify-content-end" id="navigation">
					<ul class="navbar-nav">
						<li class="nav-item  active ">
							<router-link :to="{ name: 'login' }" class="nav-link">
								<i class="nc-icon nc-tap-01"></i> Login
							</router-link>
						</li>
						<li class="nav-item">
							<a href="https://www.bigscoots.com/contact/" class="nav-link" target="_blank">
								<i class="nc-icon nc-email-85"></i> Contact Support
							</a>
						</li>
					</ul>
				</div>
			</div>
		</nav>
		<!-- End Navbar -->
		<div class="wrapper wrapper-full-page ">
			<div class="full-page section-image">
				<div class="content">
					<div class="container mt-0">
						<div class="row justify-content-md-center">
							<div class="col-md-6">
								<div class="card text-white bg-danger p-5">
									<div class="card-header">
										<h4 class="card-title text-center display-3 font-weight-bold">Oops!</h4>
										<h6 class="card-subtitle mb-2 text-center">This is a 404 Not Found Page</h6>
									</div>
									<div class="card-body p-4">
										<p class="card-text">It seems you have managed to land onto a 404 Not Found page. The only way you can come here is either by entering a wrong URL or trying to access some URL which you should not be doing. Please use the side menus to go to the respective page you want to go. If you still have problem, please contact BigScoots Support.</p>
										<button type="button" class="btn bg-light text-secondary center" @click="$router.go(-1)">Go Back to Previous Page</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<footer class="footer footer-black  footer-white ">
					<div class="container-fluid">
						<div class="row">
							<nav class="footer-nav">
								<ul>
									<li>
										<a href="https://www.bigscoots.com/" target="_blank">Bigscoots</a>
									</li>
									<li>
										<a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">WordPress Hosting</a>
									</li>
									<li>
										<a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">Privacy Policy</a>
									</li>
									<li>
										<a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">SLA</a>
									</li>
								</ul>
							</nav>
							<div class="credits ml-auto">
								<span class="copyright">
									© {{ currentYear }}, made with
									<i class="fa fa-heart heart"></i> by <a href="https://acnam.com" class="text-light" target="_blank">Acnam</a>
								</span>
							</div>
						</div>
					</div>
				</footer>
				<div class="full-page-background"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "errorPageNotFound",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss">
.error-page {
  .full-page-background {
    background-image: url("../assets/img/bg/fabio-mangione.jpg");
  }
  .section-image {
    &:after {
      background-color: rgba(90, 124, 253, 0.94);
    }
  }
  .login-bs-logo {
    max-height: 60px;
  }
}
</style>